export const SUBSTATION_COORDS = {
    "Camp Williams": [40.4866, -111.9961],
    "Mona": [39.9538, -111.8621],
    "Delta / IPP Switchyard": [39.3522, -112.5772],
    "Mercer": [40.3755, -112.0336],
    "Oquirrh": [40.6500, -112.0250],
    "Terminal": [40.7899, -111.9791],
    "Spanish Fork": [40.1149, -111.6549],
    "Sigurd": [38.8466, -111.9552],
    "Limber": [40.4491, -112.2983],
    "Pinto": [37.5900, -113.2844],
    "Red Butte": [37.3000, -113.3000],
    "Ben Lomond": [41.2200, -111.9700],
    "Bridgerland": [41.7350, -111.8340],
    "Three Peaks": [37.6775, -113.0619],
    "Bonanza": [40.0867, -109.3937],
  };
  